import { useState } from "react"
import { useNavigate } from "react-router"
import { Formik, FormikValues } from "formik"
import * as Yup from "yup"

import { genericErrMsg } from "../../../api/auth"
import { useBirddogLogin } from "../hooks/useBirddogLogin"
import BirddogLoginFormComponent from "./BirddogLoginFormComponent"

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please provide a valid email address.")
    .required("Please provide your email address."),
  password: Yup.string().required("Please provide a password."),
})

const BirddogLoginForm = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const navigate = useNavigate()

  const { mutateAsync: birddogLogin } = useBirddogLogin({
    onSuccess: (data: any) => {
      // Check if user has BirdDog role (either forester or timber_buyer)
      if (data.birddog_role) {
        // Redirect to BirdDog dashboard
        navigate("/birddog/dashboard")
      } else {
        // Regular NCX user, redirect to main platform
        setErrorMessage(
          "This login is for BirdDog users only. Please use the main NCX login."
        )
      }
    },
    onError: (error: { detail: string }) => {
      setErrorMessage(error?.detail || genericErrMsg)
    },
  })

  const onSubmit = async (values: FormikValues) => {
    await birddogLogin({
      email: values.email,
      password: values.password,
    })
  }

  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
      }}
      validationSchema={validationSchema}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={onSubmit}
    >
      {(formikProps) => (
        <BirddogLoginFormComponent
          {...formikProps}
          errorMessage={errorMessage}
        />
      )}
    </Formik>
  )
}

export default BirddogLoginForm
